(function(){
  const section=document.querySelector('[data-section-id="{{ section.id }}"]');
  if(!section) return;

  const cats=section.querySelectorAll('.kb-category-item');
  const panels=section.querySelectorAll('.kb-panel');
  const search=section.querySelector('.kb-search');

  cats.forEach(cat=>{
    console.log(222,'bbbb');
    cat.addEventListener('click',()=>{
      cats.forEach(c=>c.classList.remove('active'));console.log(111,'aa1');
      panels.forEach(p=>p.classList.remove('active'));
      cat.classList.add('active');
      section.querySelector('#'+cat.dataset.target).classList.add('active');
    })
  })

  section.querySelectorAll('.kb-question').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const expanded=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded',!expanded);
      btn.nextElementSibling.toggleAttribute('hidden');
    })
  })

  if(search){
    search.addEventListener('input',()=>{
      const q=search.value.toLowerCase();
      section.querySelectorAll('.kb-item').forEach(item=>{
        const text=item.querySelector('.kb-question span').innerText.toLowerCase();
        item.classList.toggle('hidden',!text.includes(q));
      })
    })
  }
})();